import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const VerifyCredentialPageContext = React.createContext({});
export let verifyCredentialMachine: any;

const MODULE_NAME = "machines.verifyCredential";
const log: any = LoggerModule?.getInstance();

export const useSMVerifyCredential = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  verifyCredentialMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(verifyCredentialMachine);

  // useEffect(() => {
  //   send({ type: "START" });
  // }, []);

  return {
    verifyCredentialMachine,
    verifyCredentialState: state,
    verifyCredentialSend: send,
  };
};
